module.exports = __webpack_public_path__ + "static/media/merchandises.b17b7959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/transport/merchandises.png
// module id = 149
// module chunks = 0 4